//

import { CSSTransition } from 'react-transition-group';
import FadeComponent from './FadeComponent';
import { jsx as _jsx } from "react/jsx-runtime";
const duration = 300;
export default function FadeTransition({
  children,
  required,
  visible
}) {
  return /*#__PURE__*/_jsx(CSSTransition, {
    in: visible,
    timeout: duration,
    children: state => /*#__PURE__*/_jsx(FadeComponent, {
      required: required,
      state: state,
      children: children
    })
  });
}